module.exports = __webpack_public_path__ + "img/yi.3eac18a9.png";